import { snackbarAtom } from '@/stores/layout';
import { AlertProps } from '@mui/material';
import { useAtomCallback } from 'jotai/utils';
import React, { useCallback } from 'react';

export interface useSnackBarProps {}

export const useSnackbar = (props?: useSnackBarProps) => {
  const enqueueSnackbar = useAtomCallback(
    useCallback(
      (
        get,
        set,
        msg: React.ReactNode,
        opts?: { variant?: AlertProps['severity'] }
      ) => {
        set(snackbarAtom, {
          variant: opts?.variant ?? 'info',
          msg,
          open: true,
        });
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      []
    )
  );

  return { enqueueSnackbar };
};
